import React, { Component } from 'react';

import WithData from './WithData';

class Collection extends Component {
    render() {
        const { 
            step = {}, 
            inputs,
            is_approved,
            errors,
        } = this.props;
        return (
            <WithData
                key={'with-data'}
                step={step}
                updateStep={this.props.updateStep}
                is_approved={is_approved}
                errors={errors}
                inputs={inputs}
                selected_item_id={this.props.selected_item_id}
            />
        ) 
    }
}

export default Collection;